import { persistentReducedStream } from '@ardoq/rxbeach';
import { reducers } from './reducers';
import { getDefaultState } from './utils';

const surveyCompletenessConditions$ = persistentReducedStream(
  'surveyCompletenessConditions$',
  getDefaultState(),
  reducers
);

export { surveyCompletenessConditions$ };
